import { render, staticRenderFns } from "./StepCertificate.vue?vue&type=template&id=2cb79a34&scoped=true&"
import script from "./StepCertificate.vue?vue&type=script&lang=js&"
export * from "./StepCertificate.vue?vue&type=script&lang=js&"
import style0 from "./StepCertificate.vue?vue&type=style&index=0&id=2cb79a34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2cb79a34",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VFileInput } from 'vuetify/lib/components/VFileInput';
import { VForm } from 'vuetify/lib/components/VForm';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAlert,VCol,VFileInput,VForm,VRow,VTextField})
